import { render, staticRenderFns } from "./BipSchools1.vue?vue&type=template&id=06e6ed40&scoped=true&"
import script from "./BipSchools1.vue?vue&type=script&lang=js&"
export * from "./BipSchools1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e6ed40",
  null
  
)

export default component.exports